import React from 'react';

import { capitalizeFirstLetter } from '../../blocks/utils/general-utils';

/**
 * BlockInfo
 *
 * A DWT reusable component
 *
 * @param {Object} props
 * @param {string} props.featureBy
 */
const FilterHeading = React.forwardRef( ({ context, postTitle, recordCount, error }, filterHeadingRef ) => {
  return (
    <div className='filters__heading text-[#121212] mb-5 col-span-full lg:col-start-1 lg:col-end-4 lg:mb-10' ref={ filterHeadingRef }>
      <h3 className='heading-3 mt-0 mb-7'>{ postTitle }</h3>
      <h4 className='my-0'>{ error ? 0 : recordCount } { capitalizeFirstLetter( context.featureBy ) }</h4>
    </div>
  );
});

export default FilterHeading;
